/**
 * Regisztráció feature szövegei
 *
 * Namespace: registration
 */
export const registration = {
  // Oldal
  page: {
    title: "Fiók létrehozása",
    subtitle: "Add meg az adataidat a regisztrációhoz",
    hasAccount: "Már van fiókod?",
    signIn: "Jelentkezz be",
  },

  // Űrlap mezők
  form: {
    firstNameLabel: "Keresztnév",
    firstNamePlaceholder: "János",
    lastNameLabel: "Vezetéknév",
    lastNamePlaceholder: "Kovács",
    emailLabel: "Email cím",
    emailPlaceholder: "te@example.com",
    passwordLabel: "Jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    organizationLabel: "Szervezet neve",
    organizationPlaceholder: "Szervezet Kft.",
    organizationHelperText: "Add meg a szervezeted nevét",
    accountTypeLabel: "Fiók típusa",
    isIndividualLabel: "Egyéni regisztráció (nem szervezet nevében)",
    acceptPrivacyPolicy: "Elfogadom az",
    privacyPolicyLink: "Adatvédelmi szabályzatot",
    acceptTermsOfService: "Elfogadom a",
    termsOfServiceLink: "Felelősségi nyilatkozatot",
    submitButton: "Fiók létrehozása",
    loadingButton: "Fiók létrehozása...",
  },

  // Hibaüzenetek (backend error code mapping)
  errors: {
    emailNotUnique: "A megadott email cím már használatban van",
  },

  // Sikeres regisztráció
  success: {
    title: "Fiók létrehozva!",
    message: "Kérjük, ellenőrizd az email fiókodat a megerősítéshez.",
    goToLogin: "Tovább a bejelentkezéshez",
  },
} as const;

export type RegistrationMessages = typeof registration;
